import SidePanel from 'modules/SidePanel/SidePanel'
import { useSidePanel } from 'modules/SidePanel/hooks/useSidePanel'

export default SidePanel

export { useSidePanel }
export { default as Reducer } from './store/reducer'
export { default as Sagas } from './store/saga'
